<template>
  <div>
    <el-card>
      <el-upload
        :action="action"
        :headers="headers"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
        :limit="10"
        :on-exceed="handleExceed"
        multiple
      >
        <el-button type="primary">上传图片</el-button>
      </el-upload>

      <el-table :data="imageList" border style="width: 100%; max-height: 600px; overflow-y: auto;">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="title" label="图片名称" />
        <el-table-column label="预览">
          <template #default="{ row }">
            <el-image :src="img_url + row.image_url" :preview-src-list="[img_url + row.image_url]" style="width: 100px; height: 100px" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="pagination.page"
        :page-size="pagination.limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getImages, deleteImage } from '@/api/image';

export default {
  data() {
    return {
      imageList: [],
      pagination: {
        page: 1,
        limit: 20
      },
      total: 0,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      action: process.env.VUE_APP_API_BASE_URL + '/upload',
      img_url: process.env.VUE_APP_MEDIA_URL
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const {data}= await getImages({
        page: this.pagination.page,
        limit: this.pagination.limit
      });
      console.log(data);
      this.imageList = data.rows;
      this.total = data.count;
    },
    handleUploadSuccess(response) {
      this.$message.success('上传成功');
      this.fetchData();
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件');
      }
      return isImage;
    },
    handleExceed() {
      this.$message.warning('最多只能上传10张图片');
    },
    async handleDelete(row) {
      try {
        await deleteImage(row.id);
        this.$message.success('删除成功');
        this.fetchData();
      } catch (error) {
        this.$message.error('删除失败');
      }
    },
    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.el-card {
  margin: 20px;
}

.el-upload {
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>